/** Main PDP package and upsells */
import fightcamp from './fightcamp';
import partnerWorkoutPack from './partnerWorkoutPack';
import additionalPartnerWorkoutPack from './additionalPartnerWorkoutPack';
import partnerWorkoutPackGift from './partnerWorkoutPackGift';

import sandDeliveryService from './sandDeliveryService';

import consoleFourTrackers from './includes/console-four-trackers';
import ankleWraps from './includes/fightcamp-ankle-wraps';
import bagRing from './includes/fightcamp-bag-ring';
import bag from './includes/fightcamp-boxing-bag';
import gloves from './includes/fightcamp-gloves';
import hrm from './includes/fightcamp-heart-rate-monitor';
import quickWraps from './includes/fightcamp-quick-wraps';
import soundSleeve from './fightcamp-sound-sleeve';
import v4packages from './packages';

export default {
  fightcamp,
  partnerWorkoutPack,
  additionalPartnerWorkoutPack,
  partnerWorkoutPackGift,
  sandDeliveryService,
  consoleFourTrackers,
  ankleWraps,
  bagRing,
  bag,
  gloves,
  hrm,
  quickWraps,
  soundSleeve,
  connect: v4packages[0],
  complete: v4packages[1],
  elite: v4packages[2],
};
